module.exports = __webpack_public_path__ + "media/KZ-AKT.0d651529.ogg";